import { Prohibit } from '@phosphor-icons/react';

export default Prohibit;
